import { Award, TrendingDown, TrendingUp } from "lucide-react";

export function CheapestStoresTableCard({ cheapestStoresData }) {
  const data = cheapestStoresData || [];
  const totalSavings = data.reduce((acc, item) => acc + Math.max(item.savings, 0), 0);

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center gap-2">
            <Award size={20} className="text-primary-custom" />
            <h3 className="h5 fw-semibold mb-0">Melhores Preços da Comunidade</h3>
          </div>
          <span className="badge badge-primary-custom">Comparado com outros usuários do Argus</span>
        </div>

        {data.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center text-center" style={{ height: '200px' }}>
            <p className="text-muted-custom mb-0">
              Nenhuma comparação disponível ainda — assim que outros usuários registrarem preços dos produtos que você compra, a comparação aparece aqui.
            </p>
          </div>
        ) : (
          <>
            <div className="table-responsive" style={{ maxHeight: '360px', overflowY: 'auto' }}>
              <table className="table table-hover mb-0 table-custom">
                <thead>
                  <tr style={{ borderBottom: '1px solid var(--color-border)' }}>
                    <th className="text-muted-custom small fw-semibold border-0 pb-3">Produto</th>
                    <th className="text-muted-custom small fw-semibold border-0 pb-3">Melhor Loja</th>
                    <th className="text-muted-custom small fw-semibold border-0 pb-3">Melhor Preço</th>
                    <th className="text-muted-custom small fw-semibold border-0 pb-3">Economia</th>
                    <th className="text-muted-custom small fw-semibold border-0 pb-3">vs. Você</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    const gotBestPrice = item.savings <= 0;
                    return (
                      <tr key={item.produto_id} style={{ borderBottom: '1px solid rgba(45, 55, 72, 0.3)' }}>
                        <td className="border-0 py-3">{item.produto_nome}</td>
                        <td className="border-0 py-3">
                          <span className="badge badge-primary-custom">{item.best_store}</span>
                        </td>
                        <td className="text-primary-custom fw-semibold border-0 py-3">
                          R${item.best_price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </td>
                        <td className="border-0 py-3">
                          <div className="d-flex align-items-center gap-2">
                            {gotBestPrice ? (
                              <TrendingUp size={14} className="text-primary-custom" />
                            ) : (
                              <TrendingDown size={14} className="text-primary-custom" />
                            )}
                            <span className="text-primary-custom small fw-semibold">
                              {gotBestPrice
                                ? 'Você já tem o melhor preço'
                                : `R$${item.savings.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                            </span>
                          </div>
                        </td>
                        <td className="text-primary-custom small border-0 py-3">
                          {gotBestPrice ? '—' : `${item.savings_percent.toFixed(1)}%`}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="mt-4 summary-box">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="small text-muted-custom mb-1">Economia Potencial Total</p>
                  <h4 className="h4 text-primary-custom fw-bold mb-0">
                    R${totalSavings.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </h4>
                </div>
                <div className="text-end">
                  <p className="small text-muted-custom mb-1">Comprando nas lojas mais baratas</p>
                  <p className="small mb-0">Preços registrados pela comunidade Argus</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
